import Layout from "@/layout";

export default {
  path: "/self-order",
  component: Layout,
  redirect: "/self-order/index",
  hidden: true,
  children: [
    {
      path: 'index',
      name: "SelfOrder",
      component: () => import(/* webpackChunkName: "self-order" */ "@/views/diamond/self-order"),
      meta: {
        roles: ["diamond", "admin"],
        activeMenu: '/setting/update-subscription'
      }
    },
  ]
}